import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { makeSentryIgnoredError } from '../ErrorBoundaryPage';
/** Triggers an error-boundary if we failed to fetch feature-flags. */ export default function FeatureFlagsGuard(props) {
    const featureFlags = useStore(selectors.ff.featureFlags);
    if (featureFlags.error) {
        throw makeSentryIgnoredError('failed to fetch featureFlags: ' + featureFlags.error);
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
}
